const projectListWidgets = [
  {
    id: 1,
    isDesign1: true,
    time: "Updated 3hrs ago",
    img: 'assets/images/brands/slack.png',
    label: 'Slack brand logo design',
    caption: 'Create a Brand logo design for a velzon admin.',
    number: '18/42',
    progressBar: 34,
    date: '10 Jul, 2021',
    users: [
      {
        name: 'Darline Williams',
        profile: 'assets/images/users/avatar-2.jpg'
      },
      {
        name: 'Add Members',
        text: "+",
        variant: 'bg-light text-primary'
      }
    ],
    isIcon: true
  },
  {
    id: 2,
    isDesign1: true,
    time: "Last update : 08 May",
    img: 'assets/images/brands/dribbble.png',
    label: 'Redesign - Landing page',
    caption: 'Resign a landing page design. as per abc minimal design.',
    number: '22/56',
    progressBar: 54,
    date: '18 May, 2021',
    users: [
      {
        name: 'Brent Gonzalez',
        profile: 'assets/images/users/avatar-3.jpg'
      },
      {
        name: 'Sylvia Wright',
        text: 'S',
        variant: 'bg-secondary'
      },
      {
        name: 'Ellen Smith',
        profile: 'assets/images/users/avatar-4.jpg'
      },
      {
        name: "Add Members",
        text: '+',
        variant: 'bg-light text-primary'
      }
    ]
  },
  {
    id: 3,
    isDesign1: true,
    time: "Updated 2hrs ago",
    img: 'assets/images/brands/mail_chimp.png',
    label: 'Chat Application',
    caption: 'Create a Chat application for business messaging needs. Collaborate efficiently with secure direct messages and group chats.',
    number: '14/20',
    progressBar: 65,
    date: '21 Feb, 2021',
    users: [
      {
        name: 'Jeffrey Salazar',
        profile: 'assets/images/users/avatar-5.jpg'
      },
      {
        name: 'Mark Williams',
        text: 'M',
        variant: 'bg-warning'
      },
      {
        name: "Add Members",
        text: '+',
        variant: 'bg-light text-primary'
      }
    ]
  },
  {
    id: 4,
    isDesign1: true,
    time: "Last update : 21 Jun",
    img: 'assets/images/brands/dropbox.png',
    label: 'Project App',
    caption: 'Create a project application for a project management and task management.',
    number: '20/34',
    progressBar: 78,
    date: '03 Aug, 2021',
    users: [
      {
        name: 'Kristin Turpin',
        text: 'K',
        variant: 'bg-info'
      },
      {
        name: 'Mary Leavitt',
        text: 'M',
        variant: 'bg-danger'
      },
      {
        name: "Add Members",
        text: '+',
        variant: 'bg-light text-primary'
      }
    ],
    isIcon: true
  },
  {
    id: 5,
    isDesign2: true,
    label: "Multipurpose landing template",
    status: 'Inprogress',
    statusClass: 'warning',
    deadline: '18 Sep, 2021',
    progressBar: 50,
    bg_color: "danger",
    users: [
      {
        name: 'Donna Kline',
        text: 'D',
        variant: 'bg-danger'
      },
      {
        name: 'Lee Winton',
        profile: 'assets/images/users/avatar-5.jpg'
      },
      {
        name: 'Johnny Shorter',
        profile: 'assets/images/users/avatar-6.jpg'
      },
      {
        name: 'Add Members',
        text: "+",
        variant: 'bg-light text-primary'
      }
    ]
  },
  {
    id: 6,
    isDesign2: true,
    label: "Dashboard UI",
    status: 'Completed',
    statusClass: 'success',
    deadline: '10 Jun, 2021',
    progressBar: 95,
    bg_color: "warning",
    users: [
      {
        name: 'Bonnie Haynes',
        profile: 'assets/images/users/avatar-7.jpg'
      },
      {
        name: 'Della Wilson',
        profile: 'assets/images/users/avatar-8.jpg'
      },
      {
        name: 'Add Members',
        text: "+",
        variant: 'bg-light text-primary'
      }
    ]
  },
  {
    id: 7,
    isDesign2: true,
    label: "Vector Images",
    status: 'Inprogress',
    statusClass: 'warning',
    deadline: '08 Apr, 2021',
    progressBar: 41,
    bg_color: "info",
    users: [
      {
        name: 'Chet Diaz',
        text: 'C',
        variant: 'bg-info'
      },
      {
        name: 'Add Members',
        text: "+",
        variant: 'bg-light text-primary'
      }
    ],
    isIcon: true
  },
  {
    id: 8,
    isDesign2: true,
    label: "Authentication",
    status: 'Inprogress',
    statusClass: 'warning',
    deadline: '22 Nov, 2021',
    progressBar: 35,
    bg_color: "success",
    users: [
      {
        name: 'Virginia Wall',
        profile: 'assets/images/users/avatar-8.jpg'
      },
      {
        name: 'Add Members',
        text: "+",
        variant: 'bg-light text-primary'
      }
    ]
  },
  {
    id: 9,
    isDesign3: true,
    img: "assets/images/brands/dribbble.png",
    label: 'Kanban Board',
    status: 'Inprogress',
    statusClass: 'warning',
    deadline: '08 Dec, 2021',
    number: '17/20',
    progressBar: 71,
    bg_color: "bg-secondary-subtle",
    users: [
      {
        name: 'Terry Moberly',
        text: 'T',
        variant: 'bg-danger'
      },
      {
        name: 'Ruby Miller',
        profile: 'assets/images/users/avatar-5.jpg'
      },
      {
        name: 'Add Members',
        text: "+",
        variant: 'bg-light text-primary'
      }
    ]
  },
  {
    id: 10,
    isDesign3: true,
    img: "assets/images/brands/slack.png",
    label: 'Ecommerce app',
    status: 'Inprogress',
    statusClass: 'warning',
    deadline: '20 Nov, 2021',
    number: '11/45',
    progressBar: 20,
    bg_color: "bg-light",
    users: [
      {
        name: 'Irma Metz',
        profile: 'assets/images/users/avatar-9.jpg'
      },
      {
        name: 'James Clem',
        profile: 'assets/images/users/avatar-10.jpg'
      },
      {
        name: 'Add Members',
        text: "+",
        variant: 'bg-light text-primary'
      }
    ],
    isIcon: true
  },
  {
    id: 11,
    isDesign3: true,
    img: "assets/images/brands/dropbox.png",
    label: 'Redesign - Landing page',
    status: 'Inprogress',
    statusClass: 'warning',
    deadline: '10 Jul, 2021',
    number: '13/26',
    progressBar: 54,
    bg_color: "bg-primary-subtle",
    users: [
      {
        name: 'Brent Gonzalez',
        profile: 'assets/images/users/avatar-3.jpg'
      },
      {
        name: 'Sylvia Wright',
        text: 'S',
        variant: 'bg-secondary'
      },
      {
        name: 'Ellen Smith',
        profile: 'assets/images/users/avatar-4.jpg'
      },
      {
        name: 'Add Members',
        text: "+",
        variant: 'bg-light text-primary'
      }
    ],
    isIcon: true
  },
  {
    id: 12,
    isDesign3: true,
    img: "assets/images/brands/mail_chimp.png",
    label: 'Multipurpose landing template',
    status: 'Completed',
    statusClass: 'success',
    deadline: '18 Sep, 2021',
    number: '25/32',
    progressBar: 75,
    bg_color: "bg-danger-subtle",
    users: [
      {
        name: 'Donna Kline',
        text: 'D',
        variant: 'bg-danger'
      },
      {
        name: 'Lee Winton',
        profile: 'assets/images/users/avatar-5.jpg'
      },
      {
        name: 'Johnny Shorter',
        profile: 'assets/images/users/avatar-6.jpg'
      },
      {
        name: 'Add Members',
        text: "+",
        variant: 'bg-light text-primary'
      }
    ]
  }
]

export { projectListWidgets};
